import { LimesurveyConfigModel, getLimesurveyConfigModelForCurrentPage, LimeSurveyLocalStorageSetting } from "./models/limesurveyModel";
import { iframeResizer } from "iframe-resizer";

const SurveyMinWidth = 570;

let isSurveyVisible: boolean = false;
let isIFrameLoaded: boolean = false;

$(async () => {

    let limesurveyButton = document.getElementById('limesurvey-open-button');
    let limesurveyContainer = document.getElementById('limesurveyContainer');
    let currentConfig = getLimesurveyConfigModelForCurrentPage();

    if (limesurveyButton && limesurveyContainer && currentConfig) {

        if (limesurveyButton && limesurveyContainer) {
            limesurveyButton.onclick = (_: MouseEvent) => {
                toggleSurvey(limesurveyContainer, currentConfig);
            };
        }

        const limeSurveyFrame = document.getElementById('limesurveyFrame') as HTMLIFrameElement;

        iframeResizer({
            log: false,
            checkOrigin: false,
            minWidth: SurveyMinWidth,
        },
        limeSurveyFrame);

        limeSurveyFrame.src = currentConfig.url;
        limeSurveyFrame.title = currentConfig.title;
        limeSurveyFrame.onload = window.ETDR.IFrameLoad();

        setupLimesurveyEventListeners(limesurveyContainer, limesurveyButton, currentConfig);

        if (currentConfig.firstShowUpTimeInSeconds) {
            setTimeout(() => {
                showSurvey(limesurveyContainer)
            }, currentConfig.firstShowUpTimeInSeconds * 1000);
        }
    }
});

export function IFrameLoad() {
    isIFrameLoaded = true;
}

function toggleSurvey(container: HTMLElement, currentconfig: LimesurveyConfigModel): void {
    if (isSurveyVisible) {
        hideSurvey(container, currentconfig.showUpTimeAgainInSeconds);
    }
    else {
        showSurvey(container, true);
    }
}

function showSurvey(container: HTMLElement, openedByUser: boolean = false) {
    const hasSurveySubmitted: boolean = checkIfSurveyIsSubmitted();

    if (hasSurveySubmitted && !openedByUser && !isIFrameLoaded) {
        return;
    }

    isSurveyVisible = true;
    container.classList.remove('invisible');
}

function hideSurvey(container: HTMLElement, timeoutInSecondsForShowUpAgain: number): void {
    isSurveyVisible = false;
    container.classList.add('invisible');

    setTimeoutForShowUpAgain(container, timeoutInSecondsForShowUpAgain);
}

function showSurveyToggleButton(toggleButton: HTMLElement): void {
    toggleButton.classList.remove('invisible');
}

function setupLimesurveyEventListeners(container: HTMLElement, toggleButton: HTMLElement, currentConfig: LimesurveyConfigModel) {
    window.addEventListener('message', (event) => {
        if (!event.data) {
            return;
        }

        if (event.data.messageType === 'afterSubmit') {
            setTimeout(() => {
                hideSurvey(container, currentConfig.showUpTimeAgainInSeconds);
                storeSubmission(currentConfig);
            }, 2000);
        }
        else if (event.data.messageType === 'contentLoaded') {
            showSurveyToggleButton(toggleButton);
            sendStyleInfoToSurveyIFrame();
        }
    }, false);

    document.getElementById('limesurvey-close').addEventListener('click', (_: MouseEvent) => {
        hideSurvey(container, currentConfig.showUpTimeAgainInSeconds);
    });
}

function sendStyleInfoToSurveyIFrame(): void {
    const limeSurveyFrame = document.getElementById('limesurveyFrame') as HTMLIFrameElement;
    
    const themeColors = {
        'messageType': 'style',
        'styles': {
            'btnPrimaryBgColor': getCssRulePropertyValue('.btn-primary', 'background-color'),
            'btnPrimaryHoverBgColor': getCssRulePropertyValue('.btn-primary:hover', 'background-color')
        }
    };

    limeSurveyFrame.contentWindow.postMessage(themeColors, '*');
}

function getCssRulePropertyValue(ruleName: string, propertyName: string): string {
    let styles: StyleSheetList = document.styleSheets;

    for (let i = 0; i < styles.length; i++) {
        let rules: CSSRuleList = styles[i].cssRules;

        for (let j = 0; j < rules.length; j++) {
            let rule: CSSStyleRule = rules[j] as CSSStyleRule;

            if (rule.selectorText === ruleName) {
                return rule.style.getPropertyValue(propertyName);
            }
        }
    }
}

function setTimeoutForShowUpAgain(limesurveyContainer: HTMLElement, timeoutInSecondsForShowUpAgain: number): void {
    if (timeoutInSecondsForShowUpAgain && timeoutInSecondsForShowUpAgain > 0) {
        setTimeout(() => {
            showSurvey(limesurveyContainer)
        }, timeoutInSecondsForShowUpAgain * 1000);
    }
}

function storeSubmission(currentConfig: LimesurveyConfigModel): void {
    let limeSurveyLocalStorageSettings: Array<LimeSurveyLocalStorageSetting> = JSON.parse(localStorage.getItem('LimeSurveySettings'));

    if (!limeSurveyLocalStorageSettings) {
        limeSurveyLocalStorageSettings = new Array<LimeSurveyLocalStorageSetting>();
    }

    let currentConfigIdx: number = limeSurveyLocalStorageSettings.findIndex(model => currentConfig.pathname.includes(model.pathname));

    if (currentConfigIdx != -1) {
        limeSurveyLocalStorageSettings[currentConfigIdx].submitted = true;
    } else {
        const newItem: LimeSurveyLocalStorageSetting = { pathname: currentConfig.pathname, submitted: true };

        limeSurveyLocalStorageSettings.push(newItem);
    }

    localStorage.setItem('LimeSurveySettings', JSON.stringify(limeSurveyLocalStorageSettings));
}

function checkIfSurveyIsSubmitted(): boolean {
    const limeSurveyLocalStorageSettings: Array<LimeSurveyLocalStorageSetting> = JSON.parse(localStorage.getItem('LimeSurveySettings'));
    const currentLocalStorageConfig: LimeSurveyLocalStorageSetting = limeSurveyLocalStorageSettings ? limeSurveyLocalStorageSettings.find(model => model.pathname.includes(model.pathname)) : null;

    return currentLocalStorageConfig && currentLocalStorageConfig.submitted;
}
